import { ReactElement } from 'react';
import {
    ClipboardTickIcon,
    FrontedgeBankIcon,
    ShieldTickIcon,
    UserEditIcon
} from '../../../../components/icons';
import { SuitUIButton } from '../../../../components/SuitUIButton';

interface FeatureItem {
    icon: ReactElement;
    text: string;
}

const featureList: FeatureItem[] = [
    {
        icon: <ShieldTickIcon />,
        text: 'Credentials are encrypted'
    },
    {
        icon: <UserEditIcon />,
        text: 'Your account cannot be modified or edited'
    },
    {
        icon: <ClipboardTickIcon />,
        text: 'Consent is required to access data or move money'
    }
];

const ListItem = ({ icon, text }: FeatureItem) => {
    return (
        <div className='flex items-center gap-[10px] mb-[13px]'>
            {icon}
            <p className='text-[14px] leading-[20px] text-gray200 max-w-[218px]'>
                {text}
            </p>
        </div>
    );
};

interface WelcomeProps {
    onContinue: () => void;
}

const Welcome = ({ onContinue }: WelcomeProps) => {
    return (
        <div className='h-[617px] flex flex-col justify-center items-center'>
            <FrontedgeBankIcon />
            <p className='text-[20px] leading-[30px] text-deeMidnightBlue mt-6'>
                Connect your bank to
            </p>
            <p className='text-[20px] leading-[30px] text-deeMidnightBlue font-semibold mb-6'>
                Frontedge
            </p>

            <div className='border border-gray rounded-[12px] py-[25px] px-[18px] mb-[38px]'>
                {featureList.map((item, index) => (
                    <ListItem key={index} icon={item.icon} text={item.text} />
                ))}
            </div>

            <p className='max-w-[347px] text-center text-[14px] leading-[20px] text-gray700 mb-6'>
                By continuing, you agree to FrontEdge’s{' '}
                <a
                    href='https://frontedge.io/privacy'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-gray700 underline underline-offset-2'
                >
                    privacy policy
                </a>{' '}
                and receiving updates on FrontEdge.io
            </p>

            <SuitUIButton
                text='Continue'
                onClick={onContinue}
                fullWidth
                style='max-w-[347px]'
            />
        </div>
    );
};

export default Welcome;
